import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { InputPassword } from 'components';
import { t } from 'utils/getLiteral';

class CrudPassword extends PureComponent {
    handleClear = () => {
        const { input } = this.props;
        input.onChange('');
    };

    onBlur = () => {
        const { input, onBlur = () => null } = this.props;
        onBlur(input);
    };

    render() {
        const {
            input,
            placeholder = 'cfm_placeholder_type_value',
            readOnly,
            onFocus,
            meta: { touched, error },
        } = this.props;
        const { name, value, onBlur, onFocus: onFocusInput, ...rest } = input;

        const cleanVal = value !== undefined && value !== null ? value.toString() : '';

        const hasError = touched && error && error.length > 0;

        return (
            <Fragment>
                <InputPassword
                    placeholder={t(placeholder)}
                    autoComplete="off"
                    readOnly={readOnly}
                    onClearClick={this.handleClear}
                    value={cleanVal}
                    onBlur={this.onBlur}
                    hasError={hasError}
                    name={name}
                    id={name}
                    onFocus={onFocus}
                    {...rest}
                />
                {hasError && error === 'Required' && (
                    <p className="crud-error-message">{t('cfm_label_required_field')}</p>
                )}
                {hasError && error === 'invalidPassword' && (
                    <p className="crud-error-message">{t('cfm_label_invalid_password')}</p>
                )}
            </Fragment>
        );
    }
}

CrudPassword.propTypes = {
    input: PropTypes.shape({}).isRequired,
    meta: PropTypes.shape({}).isRequired,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
};

export default CrudPassword;
